enum DynamicProduct {
  app = 'app',
  paypal = 'paypal',
  paypalLeadForm = 'paypal-lead-form',
  braintreeLeadForm = 'braintree-lead-form',
  sba = 'sba',
}

export default DynamicProduct;
